@import '../utils/global.module.less';

@selected-orange-svg: url('data:image/svg+xml;base64,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');
@selected-blue-svg: url('data:image/svg+xml;base64,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');

.back_to_workstreams {
    background-color: #243a5c;
    height: 40px;
    border-radius: 15px 0 0 0;
    color: white;
    font-family: 'Lust Text', serif !important;
    font-size: 16px;
    font-weight: 300;
    font-style: italic;
    padding: 8px 10px;
    margin: 0px;
    width: calc(100% + 5px);
}

.deleteFact {
    background-color: rgb(212, 206, 206);
    padding: 2px 6px;
    margin-left: 10px;
    border: 10px;
    border-radius: 20px;
    &:hover {
        background-color: rgb(239, 147, 147);
        transform: scale(1.2);
        cursor: pointer;
    }

    .small-shadow();
}

.dropdownItem {
    font-family: Hanken Grotesk;
    font-size: 14px;
    font-weight: normal;
}

.narrTreeFlex {
    border: 1px solid #eceef2;
    border-width: 1px 5px 1px 1px;
    border-radius: 15px 0px 0px 0px;
    //This is to pre-cache them so they don't delay load when used
    background-image: @selected-orange-svg, @selected-blue-svg;
    background-size: 0px 0px;
    background-repeat: no-repeat;
    background-color: white;
}

.back_button {
    position: relative;
    top: 1px;
    height: 24px;
    width: 24px;
    background-color: #2075f4;
    border-radius: 8px;
    border: none;
    &:hover {
        background-color: #1864c6;
        transform: scale(1.1);
    }
    &:active {
        background-color: #1e52a1;
        transform: scale(1);
    }
    transition: all 0.2s ease;
    margin-right: 12px;
    z-index: 10;
}

.main_item_text {
    color: black;
    font-family: Hanken Grotesk;
    font-size: 16px;
    margin-right: 4px;
    margin-left: 2px;
    line-height: 1.5;
}
.item_text {
    color: black;
    font-family: Hanken Grotesk;
    font-size: 16px;
    margin-right: 4px;
    line-height: 1;
}
.item_id_style {
    .item_text();
    font-weight: 500;
}
.rendered_selected_styling {
    position: relative;
    & > :global(.item_hypothesis) {
        margin-right: 40px;
    }

    & > :global(.item_hypothesis) > :global(.item_index) {
        .item_id_style();
    }

    & > :global(.item_hypothesis) > :global(.item_text) {
        .item_text();
    }
}
.group_container_depth0 {
    background-color: #f2f2f2;
    border-radius: 15px;
    padding: 10px !important;
    width: 100%;
    margin-bottom: 1000px;
    .rendered_selected_styling();
}

.group_container_depth1 {
    background-color: #dfdfdf;
    border-radius: 15px;
    padding: 10px !important;
    margin-left: 10px;
    .rendered_selected_styling();
}

.group_container_depth2 {
    background-color: #d0d0d0;
    border-radius: 15px;
    padding: 10px !important;
    margin-left: 20px;
    .rendered_selected_styling();
}

.treeItemFlex {
    width: 100%;
    & .item_id {
        margin-right: 4px;
    }

    & .item_name {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        flex: 1;
        width: 0;
        min-width: 0;
    }

    & .fact_total {
        text-align: center;
        padding: 1px 6px;
        font-size: 14px;
        font-weight: 500;
        margin-right: 10px;
        background-color: #f1efe8;
        border-radius: 20px;
        min-width: 25px;
        margin-left: 10px;
    }
}

.supporting_fact_container {
    margin-left: 30px;
    width: 100% !important;
    & > :global(.fact_id) {
        color: black;
        font-family: Hanken Grotesk;
        font-size: 14px;
        font-weight: 600;
        padding-right: 8px;
    }

    & > :global(.fact_title) {
        color: black;
        font-family: Hanken Grotesk;
        font-size: 14px;
        border-bottom: 2px dashed #a7a8a8;
    }
}

.grid_support_fact_details {
    margin-left: 36px;
    margin-top: 6px;
    margin-bottom: 20px;
    display: grid;
    grid-template-columns: 1fr;
    row-gap: 4px;
    width: 100%;
    & > :global(.fact_grid_title) {
        color: black;
        font-family: Hanken Grotesk;
        font-size: 13px;
        font-style: italic;
        font-weight: 600;
    }

    & > :global(.fact_row_entry) {
        color: black;
        font-family: Hanken Grotesk;
        font-size: 13px;
        flex-grow: 1;
    }

    & > :global(.fact_row_quote) {
        color: black;
        font-family: Hanken Grotesk;
        font-size: 14px;
        font-style: italic;
        flex-grow: 1;
    }
}

.lustFont {
    font-family: LustTextMedium;
}

.scanButton {
    position: absolute;
    top: 20;
    right: 30;

    background: #4285f4 !important;
    border: none !important;
    border-radius: 8px !important;
    color: white !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    padding: 8px 16px !important;
    height: auto !important;
    width: auto !important;
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
    transition: all 0.2s ease !important;

    &:hover {
        background: #3367d6 !important;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15) !important;
        transform: translateY(-1px) !important;
    }

    &:active {
        background: #2851a3 !important;
        transform: translateY(0) !important;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
    }

    .plusIcon {
        font-size: 18px;
        font-weight: normal;
        color: inherit !important;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 1;
        pointer-events: none;
    }
}

.emptyState {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding-top: 90px;
    padding-left: 16px;
    padding-right: 16px;
    gap: 12px;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
}

.treeEmptyText {
    text-align: center;
    padding: 24px 16px;
    color: #98a2b3;
    font-family: 'Hanken Grotesk', sans-serif;
    font-size: 15px;
    font-weight: 500;
}

.emptyStateVideo {
    width: 72px;
    height: 72px;
    object-fit: contain;
    // Purely decorative — block hover controls / PiP button entirely.
    pointer-events: none;

    &::-webkit-media-controls,
    &::-webkit-media-controls-enclosure,
    &::-webkit-media-controls-panel {
        display: none !important;
    }
}

.emptyStateText {
    color: #98a2b3;
    font-family: 'Hanken Grotesk', sans-serif;
    font-size: 15px;
    font-weight: 500;
}

.tree {
    //max-width: 300px;
    min-height: 100px;
}

.tree[data-next-action-danger='true'] {
    --fl-border-color-selected: #dc6803;
    --fl-border-icon-svg: @selected-orange-svg;
}

.tree[data-next-action-danger='false'] {
    --fl-border-color-selected: #2075f4;
    --fl-border-icon-svg: @selected-blue-svg;
}

.tree button[role='treeitem'] {
    display: flex;
    background: transparent;
    border: none;
    width: 100%;
    padding: 0 0 2px 0;
}
.treeItemContainer {
    //max-width: 365;
    &[data-nar-item-level='L1'] {
        border-bottom: 1px solid #e3e6eb !important;
        &:first-child {
            margin-top: 10px;
        }
    }
    margin-left: 8px;
    padding-right: 4px !important;
    overflow-x: hidden;
    overflow-y: hidden;
}
.treeitem {
    width: 100%;
    text-align: left;
    background-color: white;
    margin: 6px 6px;
    &[data-nar-item-level='L2'] {
        margin: 6px 6px 2px 6px;
    }
    &[data-nar-item-level='L3'] {
        margin: 1px 6px 1px 6px;
    }
    padding: 3px 14px;
    font-weight: 550;
    position: relative;
    border-radius: 0px;
    transition: background-color 0.2s ease;
    cursor: pointer;
    font-family: Hanken Grotesk;
    color: #475467;
    height: 32px;
    &:hover {
        background-color: #f1efe8 !important;
        border-radius: 10px;
    }
    &.selected {
        background-color: #eee;
        border-radius: 8px;
    }
    &.selected .fact_total {
        background-color: rgb(232, 231, 228);
    }

    &[data-nar-item-level='L3'] {
        padding: 3px 8px 3px 14px;
        & .fact_total {
            margin-right: 0px !important;
        }
    }

    &.selected_chat_context {
        border-color: var(--fl-border-color-selected) !important;
        border: 1.8px solid;
        border-radius: 8px;
        &:after {
            content: var(--fl-border-icon-svg);
            width: 17px;
            position: absolute;
            top: 0px;
            left: 0px;
            transform: scale(1) translate(-7px, -1.5px);
            //background-color: var(--fl-border-color-selected) !important;
            //border-radius: 99px;
        }
    }
}

.treeitem:hover {
    border-color: black;
}

.tree button[role='treeitem']:focus {
    outline: none;
}

button:focus-visible .treeitem.focused,
.treeitem.searchmatch.focused {
    outline: 2px solid black;
}

.treeitem.drop {
    border-color: var(--selected-color);
    background-color: #e1f1f8;
}

.treeitem.folder:before {
    content: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNiIgaGVpZ2h0PSI0IiB2aWV3Qm94PSIwIDAgNiA0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMC4xMjQ1MjEgMC44MjkyNTFDLTAuMTU4MzU5IDAuNTA1OTYgMC4wNzEyMzA0IC01Ljg3NzQ3ZS0wOCAwLjUwMDgxIC05LjYzMjk4ZS0wOEw1LjI5NzA0IC01LjE1NjNlLTA3QzUuNzI2NjIgLTUuNTMxODVlLTA3IDUuOTU2MjEgMC41MDU5NiA1LjY3MzMzIDAuODI5MjUyTDMuMjc1MjEgMy41Njk5NkMzLjA3NjAxIDMuNzk3NjIgMi43MjE4NCAzLjc5NzYyIDIuNTIyNjQgMy41Njk5NkwwLjEyNDUyMSAwLjgyOTI1MVoiIGZpbGw9IiMxMDI0NDIiLz4KPC9zdmc+Cg==);
    z-index: 1;
    transition: transform 0s ease-in-out;
    transform-origin: 50% 50%;
    transform: rotate(0deg);
    display: block;
    position: absolute;
    right: 8px;
    top: 0px;
}

.treeitem.folder.expanded:before {
    transform: rotate(180deg) translate(0, -6px);
}

.treeitem:not(.folder) {
    margin-left: 15px;
}

.description {
    font-family: sans-serif;
    font-size: 0.8rem;
    background-color: #eee;
    border-radius: 8px;
    padding: 8px 12px;
}

.dragline {
    height: 2px;
    margin-top: -1px;
    background-color: #0366d6;
}

.dragline::before {
    content: '';
    position: absolute;
    left: 0;
    top: -3px;
    height: 4px;
    width: 4px;
    background: #fff;
    border: 2px solid #0366d6;
    border-radius: 99px;
}

.outeritem {
    display: flex;
    align-items: center;
    gap: 2px;
}
.outeritem button:not([role='treeitem']) {
    padding: 2px 4px;
    height: 80%;
}

.actionbar {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 4px;
    margin-top: 8px;
}

.foreign-dragsource,
.foreign-dropzone,
.searchbox,
.actionbtn {
    height: 30px;
    background-color: transparent;
    border: 1px solid #808080;
    padding: 0 8px;
    border-radius: 4px;
    font-size: 0.8rem;
    color: #393939;
    display: flex;
    align-items: center;
    justify-items: center;
}

.tree {
    //max-width: 500px !important;
    width: 100%;
    overflow-x: hidden;
}

.selectedNarrativeItemContainer {
    margin: 0px 1px 0px 2%;
    padding: 35px 0px 0px 0px;
    width: 100%;
    max-width: 1000px;
    height: 100%;
}
